import { render, staticRenderFns } from "./ProducaoAgricola.vue?vue&type=template&id=7783473e&lang=pug"
import script from "./ProducaoAgricola.vue?vue&type=script&lang=js"
export * from "./ProducaoAgricola.vue?vue&type=script&lang=js"
import style0 from "./ProducaoAgricola.vue?vue&type=style&index=0&id=7783473e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports